import axios from '@axios';

const base = '/api/v1/purple-post';

export default {
  translatePost(postId, languageCode = 'en') {
    return axios.post(`${base}/post/translate/${postId}`, { desired_language: languageCode });
  },
  getExistingTranslations(postId) {
    return axios.get(`${base}/translations/for-post/${postId}`);
  },
  getTranslationAnalysisForTranslation(translationId) {
    return axios.get(`${base}/translation-analysis/for-translation/${translationId}`);
  },
  getTranslationAnalysisForPost(postId) {
    return axios.get(`${base}/translation-analysis/for-post/${postId}`);
  },
};
